import { render, staticRenderFns } from "./NavExerciseMediumSet.vue?vue&type=template&id=28a70928"
import script from "./NavExerciseMediumSet.vue?vue&type=script&lang=js"
export * from "./NavExerciseMediumSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports